<template>
  <div class="container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header card-header-icon row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">Dashboard</h4>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6">
              <div class="row" style="display: flex; flex-wrap: wrap">
                <div class="col-6 pr-1">
                  <DashboardCard
                    client_name="MID"
                    value="684"
                    title="App Downloads"
                    imgSrc="my-irish-date/dashboard-app-downloads"
                  />
                </div>
                <div class="col-6 pl-1">
                  <router-link to="/my_irish_date/users" class="dashboard-card-link">
                    <DashboardCard
                      client_name="MID"
                      :value="user_count"
                      title="Users"
                      imgSrc="my-irish-date/dashboard-users"
                    />
                  </router-link>
                </div>
                <div class="col-6 pr-1">
                  <DashboardCard
                    client_name="MID"
                    value="3672"
                    title="Subscriptions"
                    imgSrc="my-irish-date/dashboard-subscriptions"
                  />
                </div>
                <div class="col-6 pl-1">
                  <DashboardCard
                    client_name="MID"
                    value="75"
                    title="Sent Invites"
                    imgSrc="my-irish-date/dashboard-sent-invites"
                  />
                </div>
              </div>
              <!-- end row of cards -->

              <div class="row">
                <div class="col-md-12">
                  <div class="card mt-1">
                    <div class="cardContentTableDiv">
                      <DashboardStatistics
                        title="Statistics"
                        subTitle="Users Per Month"
                        yAxisTitle="Number of users"
                        :categories="statisticsChartCategories"
                        :chartStyle="statisticsChartStyle"
                        :chartTitleStyle="statisticsChartTitleStyle"
                        :chartSubTitleStyle="statisticsChartSubTitleStyle"
                        :chartSeries="statisticsChartSeries"
                      />
                      <DashboardStatisticsData
                        class="m-1 mx-3"
                        client_name="MID"
                        h3Left="Weekly"
                        thisLabelLeft="This Week"
                        thisValueLeft="20"
                        lastLabelLeft="Last Week"
                        lastValueLeft="13"
                        h3Right="Monthly"
                        thisLabelRight="This Month"
                        thisValueRight="-30"
                        lastLabelRight="Last Month"
                        lastValueRight="23"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- end col-7 left side -->
            <div class="col-lg-5 col-md-5 col-sm-6">
              <DashboardTable
              client_name="MID"
                tableId="subscriptionsPerMonthTable"
                title="Subscriptions"
                subTitle="Per Month"
                :columns="columns"
                :rowsData="subscriptionsPerMonthTable"
              />
              <DashboardTable
              client_name="MID"
                tableId="subscriptionsPer3MonthTable"
                title="Subscriptions"
                subTitle="Per 3 Months"
                :columns="columns"
                :rowsData="subscriptionsPer3MonthTable"
              />
            </div>
          </div>
          <div class="card card-transparent-background">
            <div class="card-header row">
              <div class="col-md-6 pl-0">
                <h4 class="card-sub-title card-sub-title-irish-date">Map</h4>
              </div>
              <div class="col-md-6">
                <b-form-group
                  class="m-0 custom-form-group-select-sm form-group-v-select-irishdate"
                  label="Subscription type"
                  label-for="subscription_type"
                  label-class="offset-xl-4 form-label-mid"
                  label-cols-xl="4"
                  content-cols-xl="4"
                  label-cols="6"
                  content-cols="6"
                  :subscription_type="subscription_type"
                >
                  <v-select
                    :options="subscription_types"
                    name="subscription_type"
                    title="subscription_type"
                    v-model="subscription_type"
                    :reduce="(item) => item.code"
                    required
                    :clearable="false"
                  ></v-select
                ></b-form-group>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <GmapMap
                :center="map_center"
                :zoom="12"
                style="height: 500px"
                ref="gmap"
              >
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :visible="
                    subscription_type == 'all' || m.type == subscription_type
                  "
                  :position="m.position"
                  :clickable="true"
                  :draggable="false"
                  :icon="
                    m.type == 'free' ? marker_img_free : marker_img_premium
                  "
                  @click="openInfoWindowTemplate(index)"
                />
                <gmap-info-window
                  :options="{
                    maxWidth: 300,
                    pixelOffset: { width: 0, height: -25 },
                  }"
                  :position="infoWindow.position"
                  :opened="infoWindow.open"
                  @closeclick="infoWindow.open = false"
                >
                  <div v-html="infoWindow.template"></div>
                </gmap-info-window>
              </GmapMap>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

import { gmapApi } from "vue2-google-maps";

import DashboardCard from "@/components/dashboard/Card";
import DashboardTable from "@/components/dashboard/Table";
import DashboardStatistics from "@/components/dashboard/StatisticsChart";
import DashboardStatisticsData from "@/components/dashboard/StatisticsData";
import DashboardRevenueChart from "@/components/dashboard/RevenueChart";
import DashboardRevenueData from "@/components/dashboard/RevenueData";

export default {
  name: "DoOmYogaDashboard",
  components: {
    DashboardCard,
    DashboardTable,
    DashboardStatistics,
    DashboardStatisticsData,
    DashboardRevenueChart,
    DashboardRevenueData,
  },
  data() {
    return {
      google: gmapApi,
      user_count: 0,
      columns: [
        { label: "Name", key: "name", data: "name", class: "nameTd" },
        {
          label: "Re-Subscribed",
          key: "resubscribed",
          data: "resubscribed",
          class: "valueTd",
        },
        {
          label: "Payment ($)",
          key: "payment",
          data: "payment",
          class: "paymentTd",
        },
      ],
      subscriptionsPerMonthTable: [
        { name: "Sara Reda", resubscribed: 10, payment: "$100" },
        { name: "Sara Reda", resubscribed: 1, payment: "$10" },
        { name: "Sara Reda", resubscribed: 55, payment: "$500" },
        { name: "Sara Reda", resubscribed: 4, payment: "$40" },
        { name: "Sara Reda", resubscribed: 30, payment: "$300" },
        { name: "Sara Reda", resubscribed: 8, payment: "$800" },
      ],
      subscriptionsPer3MonthTable: [
        { name: "Mohamed Fayez", resubscribed: 10, payment: "$100" },
        { name: "Mohamed Fayez", resubscribed: 1, payment: "$200" },
        { name: "Mohamed Fayez", resubscribed: 55, payment: "$1000" },
        { name: "Mohamed Fayez", resubscribed: 4, payment: "$300" },
        { name: "Mohamed Fayez", resubscribed: 30, payment: "$100" },
        { name: "Mohamed Fayez", resubscribed: 8, payment: "$200" },
      ],
      statisticsChartCategories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      statisticsChartStyle: { fontFamily: "Mundial", "font-weight": "700" },
      statisticsChartTitleStyle: {
        "font-family": "Mundial",
        "font-weight": "700",
        "font-size": "20px",
        "line-height": "23px",
        color: "#23314B !important",
        "margin-top": "10px",
      },
      statisticsChartSubTitleStyle: {
        "font-family": "Mundial",
        "font-weight": "400",
        "font-size": "16px",
        "line-height": "19px",
        color: "#656565 ",
        float: "left",
      },
      statisticsChartSeries: [
        {
          color: "#F8C140",
          name: "Last year",
          data: [10, 12, 8, 10, 0, 0, 10, 0, 0, 80, 0, 0],
        },
        {
          color: "#009E61",
          name: "This year",
          data: [20, 10, 12, 30, 0, 0, 0, 0, 0, 0, 0, 0],
          //dashStyle:'Dash'
        },
      ],
      map_center: { lat: 42.6289495, lng: -78.7375289 },
      markers: [
        // {
        //   position: { lat: 42.6289495, lng: -78.7375289 },
        //   type: "free",
        //   user: { name: "sara reda" },
        // },
        // {
        //   position: { lat: 42.639495, lng: -78.755289 },
        //   type: "premium",
        //   user: { name: "rania reda" },
        // },
        // {
        //   position: { lat: 42.5639495, lng: -78.5755289 },
        //   type: "free",
        //   user: { name: "mohamed fayez" },
        // },
      ],
      marker_img_free: {
        url: require("@/assets/images/my-irish-date/map-pin-purple.png"),
        scaledSize: { width: 40, height: 40 },
      },
      marker_img_premium: {
        url: require("@/assets/images/my-irish-date/map-pin-red.png"),
        scaledSize: { width: 40, height: 40 },
      },

      infoWindow: {
        position: { lat: 0, lng: 0 },
        open: false,
        template: "",
      },
      subscription_type: "all",
      subscription_types: [
        { label: "Show all", code: "all" },
        { label: "Free", code: "free" },
        { label: "Premium", code: "premium" },
      ],
    };
  },
  methods: {
    openInfoWindowTemplate(index) {
      const location = this.markers[index];
      // console.log(location);
      this.infoWindow.position = location.position;
      this.infoWindow.template = `<p class="mapNameP">${location.user.name}</p><p class="mapAccountTypeP">${location.type} account <p>`;
      this.infoWindow.open = true;
    },
  },
  // computed: {
  //   google: gmapApi,
  // },
  mounted() {
    // console.log(window.localStorage.getItem("user"));
    // console.log(console.log(process.env))
    // console.log(console.log(process.env.VUE_APP_GOOGLE_API_KEY))
    axios
      .get("/admin/dashbord?user_count=1&user_map=1", {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          client: "MID",
          Authorization:
            "Bearer " +
            JSON.parse(window.localStorage.getItem("user")).access_token,
        },
      })
      .then((response) => {
        //console.log(response);
        let data = response.data;
        this.user_count = data.user_count;
        // console.log(data.user_map)
        // console.log(this.markers)
        let selectedMarkers = [];
        for (var i = 0; i < data.user_map.length; i++) {
          // console.log(data.user_map[i].position);
          // console.log(data.user_map[i].position.lat != null)
          if (
            data.user_map[i].position.lat != null &&
            data.user_map[i].position.lng != null
          ) {
            data.user_map[i].position.lat = Number(
              data.user_map[i].position.lat
            );
            data.user_map[i].position.lng = Number(
              data.user_map[i].position.lng
            );
            selectedMarkers.push(data.user_map[i]);
          }
        }
        // console.log(selectedMarkers);
        this.markers = selectedMarkers;

        // this.overlay_show = false;
        // table.ajax.reload()
        // console.log(this);
        // const bounds = new this.google.maps.LatLngBounds();
        // for (let m of this.markers) {
        //   bounds.extend(m.position);
        // }
        // this.$refs.gmap.$mapObject.fitBounds(bounds);

        this.$refs.gmap.$mapPromise.then((map) => {
          const bounds = new google.maps.LatLngBounds();
          for (let m of this.markers) {
            bounds.extend(m.position);
          }
          map.fitBounds(bounds);
        });
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_irish_date/Dashboard.vue